import { FRUser, UserManager, TokenManager, TokenStorage, Config } from '@forgerock/javascript-sdk';

const defaultLoginOption = 'embedded';

let loginOption : 'embedded' | 'redirect' | undefined;

export type User = {
  name: string;
  email: string;
  given_name: string;
  family_name: string;
};

export const configureForgerockSdk = (setup) => {
  Config.set({
    clientId: setup.clientId,
    redirectUri: `${window.location.origin}`,
    scope: 'pearsonUID openid profile email',
    serverConfig: {
      baseUrl: setup.serverBaseUrl,
      timeout: setup.timeout,
    },
    realmPath: setup.realmPath,
  });
  if (setup.loginOption) {
    loginOption = setup.loginOption;
  }
}

const getLoginOption = () => {
    return loginOption ? loginOption : defaultLoginOption;
}

export const getTokens = async () => {
  try {
    const tokens = (await TokenManager.getTokens({login: getLoginOption()}));
    return tokens;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const getTokensForceRenew = async () => {
  try {
    const tokens = (await TokenManager.getTokens({login: getLoginOption(), forceRenew: true}));
    return tokens;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const getLocalTokens = async () => {
  try {
    const tokens = (await TokenStorage.get());
    return tokens;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const logout = async () => {
  try {
    await FRUser.logout();
  } catch (error) {
    console.error(`Error: logout; ${error}`);
  }
};

export const getUser = async () => {
  try {
    const user = (await UserManager.getCurrentUser()) as User;
    return user;
  } catch (err) {
    console.error(err);
    return null;
  }
};
